export default __webpack_public_path__ + "static/media/invalid-circle.daa30fd8.svg";